import { ReactComponent as ShieldIcon } from 'img/icons/shield.svg';
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipAppearance, ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import { sendProtectedAnalytics } from 'reactApp/ui/ProtectedHint/ProtectedHint.analytics';

import styles from './ProtectedTooltip.css';

interface IProps {
    text: string;
    appearance?: ETooltipAppearance;
}

export const ProtectedTooltip = memo<IProps>(({ text, appearance = ETooltipAppearance.white }) => {
    const ref = useRef<HTMLDivElement>(null);
    const [showTooltip, setShowTooltip] = useState(false);
    const storage = useSelector(getCurrentStorage);

    const handleClick = useCallback(() => {
        setShowTooltip(true);
        sendProtectedAnalytics({
            action: 'view',
            place: storage,
            platform: 'touch',
        });
    }, [storage]);

    const handleClose = useCallback(() => {
        setShowTooltip(false);
    }, []);

    useEffect(() => {
        sendProtectedAnalytics({
            action: 'show',
            place: storage,
            platform: 'touch',
        });
    }, []);

    return (
        <>
            <div className={styles.root} ref={ref} onClick={handleClick}>
                <ShieldIcon />
            </div>
            {showTooltip && (
                <FloatingTooltip
                    target={ref}
                    text={text}
                    placement={ETooltipPlacement.bottom}
                    size={ETooltipSize.small}
                    appearance={appearance}
                    closeOnScroll={true}
                    onClose={handleClose}
                    qaId="tooltip-protected"
                />
            )}
        </>
    );
});

ProtectedTooltip.displayName = 'ProtectedTooltip';
